import { render, staticRenderFns } from "./ServiceItem.vue?vue&type=template&id=7ab906cf"
import script from "./ServiceItem.vue?vue&type=script&lang=js"
export * from "./ServiceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports